import { useMutation } from '@apollo/client';
import { Config } from '@otp/icons';
import { Card, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Routes } from 'src/components/common/router/constants';
import { ImpersonateUserDocument, User } from 'src/graphql/generated/graphql';
import {
  getJWTToken,
  saveImpersonatorJWTToken,
  saveJWTToken,
} from 'src/utils/auth';

type UserImpersonateCardProps = {
  user: Partial<User>;
};

export const UserImpersonateCard = ({ user }: UserImpersonateCardProps) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'manage-otps.actions',
  });

  const [impersonateUser, { loading: impersonateUserLoading }] = useMutation(
    ImpersonateUserDocument,
  );

  const handleImpersonateUser = async () => {
    const { data } = await impersonateUser({ variables: { userId: user.id } });

    if (data?.impersonateUser) {
      saveImpersonatorJWTToken(getJWTToken() as string);
      saveJWTToken(data.impersonateUser);
      window.location.href = Routes.home.path;
    }
  };

  return (
    <Card
      className="hover:bg-[var(--mui-palette-primary-200)] cursor-pointer"
      onClick={handleImpersonateUser}
    >
      <div className="grid grid-cols-12 items-center">
        <Typography variant="subtitle2" className="col-span-11">
          {t('impersonate')}
        </Typography>
        <Config />
      </div>
    </Card>
  );
};
